<template lang="pug">
div
  o0Intro
  o15Submitter
  o01GeneralEvent
  o02EventMgr
  o03SponsorInformation
  o04FinancialInformation
  o05PublicSafety
  o06EventPublicity
  o07SiteInfo
  o08Trash
  o09Parking
  o10Restrooms
  o11LocationImpact
  o12Signage
  o13Food
  o14HoldHarmless
  .pt-1
    img(v-bind:src="signature")
</template>
<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";

import o0Intro from "./o0Intro.vue";
import o01GeneralEvent from "./o01GeneralEvent.vue";
import o02EventMgr from "./o02EventMgr.vue";
import o03SponsorInformation from "./o03SponsorInformation.vue";
import o04FinancialInformation from "./o04FinancialInformation.vue";
import o05PublicSafety from "./o05PublicSafety.vue";
import o06EventPublicity from "./o06EventPublicity.vue";
import o07SiteInfo from "./o07SiteInfo.vue";
import o08Trash from "./o08Trash.vue";
import o09Parking from "./o09Parking.vue";
import o10Restrooms from "./o10Restrooms.vue";
import o11LocationImpact from "./o11LocationImpact.vue";
import o12Signage from "./o12Signage.vue";
import o13Food from "./o13Food.vue";
import o14HoldHarmless from "./o14HoldHarmless.vue";
import o15Submitter from "./o15Submitter.vue";

export default {
  components: {
    o0Intro,
    o01GeneralEvent,
    o02EventMgr,
    o03SponsorInformation,
    o04FinancialInformation,
    o05PublicSafety,
    o06EventPublicity,
    o07SiteInfo,
    o08Trash,
    o09Parking,
    o10Restrooms,
    o11LocationImpact,
    o12Signage,
    o13Food,
    o14HoldHarmless,
    o15Submitter,
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
    }),
    ...mapFields(["data.signature"]),
  },
};
</script>